import React from 'react'
import { Heading } from '../components/Heading';
import { NewsletterAdminPage } from '../components/Newsletter/NewsletterAdminPage';

export function Newsletter() {
  return (
    <>
      <Heading title="Newsletter" />
      <div className="container">
        <NewsletterAdminPage />
      </div>
    </>
  )
}

export default Newsletter
